import { Button } from "@/components/ui/Button";
import { beginSignIn } from "@/lib/platformAuth";

/**
 * Web / Platform sign-in landing. Not used inside Teams.
 * Primary CTA goes to Auth-Kit on nationaldatacare.com, Easy Auth elsewhere.
 */
export function SignInPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-6">
      <main className="w-full max-w-md rounded-2xl bg-surface p-8 text-center shadow-[0_2px_16px_rgba(15,26,46,0.07)]">
        <div className="mb-6 flex justify-center">
          <img
            src="/ndc-logo.svg"
            alt="National Datacare"
            className="h-10 w-auto select-none dark:hidden"
            draggable={false}
          />
          <img
            src="/ndc-logo-white.svg"
            alt="National Datacare"
            className="hidden h-10 w-auto select-none dark:block"
            draggable={false}
          />
        </div>
        <p className="mb-2 text-[11px] font-semibold uppercase tracking-wider text-text-muted">
          Knowledge Assistant
        </p>
        <h1
          className="m-0 mb-3 font-serif font-semibold tracking-[-0.02em] text-text"
          style={{ fontSize: "clamp(26px, 4vw, 34px)", lineHeight: 1.2 }}
        >
          Sign in to continue
        </h1>
        <p className="m-0 mb-6 text-[15px] leading-relaxed text-text-muted">
          Use your work account. If you already signed in through the NDC Platform,
          you will return here without entering a password again.
        </p>
        <Button
          variant="primary"
          className="w-full"
          onClick={() => {
            beginSignIn();
          }}
        >
          Sign in
        </Button>
      </main>
    </div>
  );
}

export function AuthCheckingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-6">
      <p className="text-[14px] text-text-muted">Checking your sign-in…</p>
    </div>
  );
}
